export default {"src":"/bnb/_next/static/media/coinbasewallet.c253eca8.svg","height":20,"width":20};